import modulesConfig from '../../../config/modules.config'

export const progressImageConfig = {
    ...modulesConfig.PROGRESS_IMAGE_CONFIG,
}